import React, { Component } from 'react';
import ReactImageFallback from "react-image-fallback";
import PropTypes from 'prop-types';

class SliderItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            imageId: ''

        };

    }


    componentDidMount() {
    }

    render() {
        let image = this.props.item;
        let itemIndex = this.props.iteration;
        let imgpath = this.props.pageSettingsData.config.IMGIX_PATH +'assets/slider/'+ image.img_name+'?fit=crop&h=500&w=800&auto=enhance&dpr=3%203x';
        let defImgSrc = require("../../assets/images/no-image.jpg");
        let im_class = "carousel-item ";


        console.log("itemIndex"+itemIndex);

        if(itemIndex === 0) {
            im_class += "active";
        }

        return (

            <div className= {im_class }>
                <ReactImageFallback
                    className="d-block w-100 "
                    src={imgpath}
                    fallbackImage={defImgSrc}
                    initialImage={defImgSrc}
                    alt="cool image should be here"
                     />
            </div>
        );
    }


}

SliderItem.propTypes = {
    toggle : PropTypes.func
}

export default SliderItem;



// WEBPACK FOOTER //
// ./src/components/gallery/SliderItem.js